(ns iris.globals
  (:require
   [reagent.core :as r]))

(defonce GOOG_I18N_TIMEZONE_UTC (.createTimeZone (.. js/goog -i18n -TimeZone) 0))

(defonce NREPLIES_COUNTER_RED 10)
(defonce NVIEWS_COUNTER_RED 1000)
(defonce NVOTES_COUNTER_RED 100)

(defonce RAID_LEN_MAX 6)
(defonce RAID_LEN_MIN 2)
(defonce RAID_LEN_DEFAULT RAID_LEN_MIN)

(defonce FONT_SIZE_DEFAULT 100)

(defonce linger (atom true))

(defonce jwt (atom nil))

(defonce fbjwt (atom nil))

(defonce login_redirect (atom nil))

(defonce jwt-payload (atom nil))

(defonce fbjwt-payload (atom nil))

(defonce AUT_JWT_COOKIE_NAME "aut")

(defonce JWT_COOKIE_NAME "c1")

(defonce FBJWT_COOKIE_NAME "c2")

(defonce THREAD_ALERT_SETTINGS
  {:storage-key "tar"
   :follow-alert-limit 50})

(defonce POSTS_SEARCH_MAXCOUNT_DEFAULT 500)

(defonce POSTS_EXCERPT_LIMIT 250)

(defonce MODERATOR_LOG_SETTINGS
  {:limit-to-last 100})

(defonce fb-user (r/atom nil))

;; logged-in true - jwt and fbjwt were set
(defonce logged-in (atom nil))

;; (defonce exec-on-fb-sign-in (atom []))
;; (defonce exec-on-fb-sign-out (atom []))

(defonce redo (atom {}))

;; (defonce fb-broadcast-channel (new js/BroadcastChannel "fb-broadcast-channel"))

;; const ThreadAlertSettings = {
;;     storageKey:  'tar',
;;     followAlertLimit: 50,
;;     newAlertTimeFrame: 12,
;;     alertDisplayLimit: 3,
;;     newAlertDisplayLimit: 3,
;;     titleCharLimit: 30,
;;     forumPathCharLimit: 27,
;;     optimalRes: 360
;; };

(defonce MAX_TAG_CHAR_COUNT 40)
(defonce MAX_TAGS_INPUT_COUNT 5)

(defonce MESSAGES_LIMIT 100)

(defonce autotags (atom nil))